export const EXPORT_HORIZONTAL_SPACE = '10mm';
export const EXPORT_VERTICAL_SPACE = '12mm';

export const CS_CONFIG = {
	tokenUrl:
		'https://33333.cke-cs.com/token/dev/CsVGNsFFFlZuRtjZpq3Z2NvWcr49g2xEKyblweOr+1wBDF+D3OiN5DcFmQ==',
	uploadUrl: 'https://33333.cke-cs.com/easyimage/upload/',
};

export const LICENSE_KEY =
	'eyJhbGciOiJFUzI1NiJ9.eyJleHAiOjE3OTIzNjgwMDAsImp0aSI6ImNiZWYyNjYyLTJhZDQtNDhhZi1iODI2LTViNWI5MzQ4YTZkNSIsImxpY2Vuc2VkSG9zdHMiOlsiKi5ja2VkaXRvci5jb20iLCJja2VkaXRvci5jb20iLCJsb2NhbGhvc3QiLCIxMjcuMC4wLjEiXSwiZGlzdHJpYnV0aW9uQ2hhbm5lbCI6InNoIiwid2hpdGVMYWJlbCI6dHJ1ZSwiZmVhdHVyZXMiOlsiQ01UIiwiVEMiLCJQQUciLCJSSCIsIkRPIiwiRlAiLCJTQyIsIlRPQyIsIlBPRSIsIlRQTCIsIkFJIiwiUFAiLCJDQyIsIkVJUyIsIkVDSCIsIk1MTCIsIk1GIiwiVVBMQyIsIlJFIiwiUkNNVCIsIlJUQyIsIlJSSCIsIkJPWCIsIkUyUCIsIkUyVyIsIklXIiwiRkkiLCJTRUUiLCJMSCIsIkNLQUkiLCJGT08iLCJEUlVQIiwiVFJJTElVTSJdLCJ2YyI6ImUxMGE4NzRiIn0.HwEINuimeCrncWfie-z1gFo8Pygr1Rrgch2g-Ls7alSoDQ5mk-0CYP2abd_nZcHzxviMvdSe4fQjtqjwKLLY6w'; // valid until 2026.10.19

export const OPENAI_AUTHORIZATION =
	'Bearer eyJhbGciOiJFUzM4NCJ9.eyJhdWQiOlsiaHR0cHM6Ly9vcGVuYWkucHVibGljLWRlbW8ucHJveHkuYWkuY2tlLWNzLmNvbS8iXSwiZXhwIjoxNzgyODY0MDAwLCJodHRwczovL29wZW5haS5wdWJsaWMtZGVtby5wcm94eS5haS5ja2UtY3MuY29tL3JvbGUiOiJja2VkaXRvci1wdWJsaWMtZGVtbyIsImlzcyI6Imh0dHBzOi8vcHVibGljLWRlbW8ucHJveHkuYWkuY2tlLWNzLmNvbS8iLCJqdGkiOiJmOTViOGQ5ZS04Zjc1LTQxZjUtYTgxNS1kMDIwNWE4ZDM4ODciLCJzdWIiOiJhaS1hc3Npc3RhbnQtZGVtbyJ9.Yr3EfRYpJn6yThWeEc5nDIp0Jis8rp8OUZTpY4hnOnW_Zv86HRT7GAnOkD87AOl3LM-2sjkwt-jvU182bs1kSQdKRTwEYeQmcJwTuHEtDWDNCDU_v712nMJuUfYNQwnp';

export const TEMPLATE_DEFINITIONS = [
	{
		title: 'Signature (multi-line)',
		data: `<p style="margin-left:2em;"><span><strong>I hereby verify that the aforementioned report has undergone thorough factual verification and reflects the most current information.</strong></span></p>
					<p style="margin-left:22em;"><br>
					<span>Signature: __________&nbsp;&nbsp;</span><br>
					<span>Name:&nbsp;</span><br>
					<span>Title:&nbsp;</span><br>
					<span>Date:</span></p>`,
		description: 'Author signature with statement',
		icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 21 21"><g clip-path="url(#a)"><path fill="#E8DFF7" d="M19.833.5H1.611a.889.889 0 0 0-.889.889V19.61a.89.89 0 0 0 .89.889h18.221a.89.89 0 0 0 .89-.889V1.39a.889.889 0 0 0-.89-.889Z"/><path fill="#fff" d="M4.722 17.167c0 .859.697 1.555 1.556 1.555h8.889c.859 0 1.555-.696 1.555-1.555V6.539c0-.448-.194-.875-.531-1.17l-2.584-2.262a1.556 1.556 0 0 0-1.025-.385H6.278c-.86 0-1.556.697-1.556 1.556v12.889Z"/><path stroke="#743CCD" stroke-width=".667" d="M16.161 5.785c.145.127.228.31.228.502v11.435a.667.667 0 0 1-.667.667h-10a.667.667 0 0 1-.667-.667v-14c0-.368.299-.666.667-.666h7.069c.161 0 .317.058.439.165l2.931 2.564Z"/><path fill="#C9FE43" d="M16.546 8.525a.917.917 0 0 1 1.402 1.18l-4.132 4.908-1.402-1.18 4.132-4.908Zm-4.494 6.76.384-1.594 1.122.944-1.506.65Z"/><path stroke="#6C34C9" stroke-linecap="round" stroke-linejoin="round" stroke-width=".55" d="m11.666 15.837 1.96-.953c.126-.061.188-.092.246-.13.051-.033.1-.07.145-.112.05-.047.096-.1.186-.207l3.766-4.474a1.037 1.037 0 1 0-1.586-1.335l-3.767 4.473c-.09.107-.135.16-.172.218a1.091 1.091 0 0 0-.087.162c-.027.063-.046.13-.085.264l-.606 2.094Zm0 0 .584-2.019c.042-.144.063-.217.106-.253a.183.183 0 0 1 .136-.04c.056.005.114.053.229.15l.896.755c.115.097.172.145.188.2a.184.184 0 0 1-.018.14c-.028.049-.096.082-.23.148l-1.89.92Z"/><path stroke="#6C34C9" stroke-linecap="round" stroke-linejoin="round" stroke-width=".444" d="m6.5 16.945.903-1.162a.569.569 0 0 1 .989.17l.062.188a.46.46 0 0 0 .797.142v0a.46.46 0 0 1 .72 0l.282.353a.823.823 0 0 0 .642.309h.938"/><rect width="4.889" height=".667" x="6.5" y="6.278" fill="#743CCD" rx=".333"/><rect width="6.667" height=".667" x="6.5" y="8.056" fill="#743CCD" rx=".333"/><rect width="4.889" height=".667" x="6.5" y="9.833" fill="#743CCD" rx=".333"/><rect width="4.889" height=".667" x="6.5" y="11.611" fill="#743CCD" rx=".333"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z" transform="translate(.722 .5)"/></clipPath></defs></svg>`,
	},
	{
		title: 'Projections table',
		data: `<figure class="table">
						<table>
							<tbody>
								<tr>
									<th>&nbsp;</th>
									<th>FY 2023</th>
									<th>FY 2024 (Projected)</th>
									<th>Change (%)</th>
								</tr>
								<tr>
									<td>Revenue ($M)</td>
									<td>8</td>
									<td>10</td>
									<td>25</td>
								</tr>
								<tr>
									<td>Net Profit ($M)</td>
									<td></td>
									<td></td>
									<td></td>
								</tr>
								<tr>
									<td>Cash Flow ($M)</td>
									<td></td>
									<td></td>
									<td></td>
								</tr>
								<tr>
									<td>ROI (%)</td>
									<td></td>
									<td></td>
									<td></td>
								</tr>
							</tbody>
						</table>
						<figcaption>
							Financial Projections
						</figcaption>
					</figure>`,
		icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 21 21"><g clip-path="url(#a)"><path fill="#E8DFF7" d="M20.055.5H1.833a.889.889 0 0 0-.889.889V19.61a.89.89 0 0 0 .89.889h18.221a.889.889 0 0 0 .89-.889V1.39a.889.889 0 0 0-.89-.889Z"/><path fill="#fff" d="M4.5 18.278h12.889a.89.89 0 0 0 .889-.89V4.057a.889.889 0 0 0-.89-.89H4.5a.889.889 0 0 0-.889.89V17.39c0 .49.398.889.889.889Z"/><path stroke="#743CCD" stroke-width=".667" d="M17.389 17.944H4.499a.556.556 0 0 1-.555-.555V4.056c0-.307.249-.556.556-.556h12.889c.307 0 .555.249.555.556v13.333a.555.555 0 0 1-.555.555Z"/><path fill="#E8DFF7" d="M8.944 4.056H8.5v13.333h.444V4.056Z"/><path fill="#E8DFF7" d="M17.389 9.389v-.445H4.499v.445h12.89Zm0 2.667v-.445H4.499v.445h12.89Zm0 2.666v-.444H4.499v.444h12.89Z"/><path fill="#E8DFF7" d="M13.389 4.056h-.445v13.333h.445V4.056Z"/><path fill="#E8DFF7" d="M17.389 6.722v-.444H4.499v.444h12.89Z"/><path fill="#743CCD" d="M8.5 4.056h-4v2.222h4V4.056Z"/><path fill="#743CCD" d="M8.5 4.056h-4v2.222h4V4.056Z"/><path fill="#DFFE8F" d="M12.944 4.056h-4v2.222h4V4.056Z"/><path fill="#E8DFF7" d="M17.389 4.056h-4v2.222h4V4.056Z"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z" transform="translate(.944 .5)"/></clipPath></defs></svg>`,
		description: 'Table for annual financial projections',
	},
	{
		title: 'Balance Sheet',
		data: `<figure class="table">
						<table>
							<tbody>
								<tr>
									<td><span><strong>Group</strong></span></td>
									<td><span><strong>Description</strong></span></td>
									<td><span><strong>Current Year ($)</strong></span></td>
									<td><span><strong>Previous Year ($)</strong></span></td>
								</tr>
								<tr>
									<td rowspan="3"><span><strong>Assets</strong></span></td>
									<td><span>Current Assets</span></td>
									<td><span>9.4</span></td>
									<td><span>8.9</span></td>
								</tr>
								<tr>
									<td><span>Non-Current Assets</span></td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
								</tr>
								<tr>
									<td><span>Total Assets</span></td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
								</tr>
								<tr>
									<td rowspan="3"><span><strong>Liabilities</strong></span></td>
									<td><span>Current Liabilities</span></td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
								</tr>
								<tr>
									<td><span>Non-Current Liabilities</span></td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
								</tr>
								<tr>
									<td><span>Total Liabilities</span></td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
								</tr>
								<tr>
									<td rowspan="4"><span><strong>Equity</strong></span></td>
									<td><span>Share Capital</span></td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
								</tr>
								<tr>
									<td><span>Retained Earnings</span></td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
								</tr>
								<tr>
									<td><span>Total Equity</span></td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
								</tr>
								<tr>
									<td><span>Total Liabilities and Equity</span></td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
								</tr>
							</tbody>
						</table>
						<figcaption>
							Balance sheet
						</figcaption>
					</figure>`,
		icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 21 21"><g clip-path="url(#a)"><path fill="#E8DFF7" d="M20.055.5H1.833a.889.889 0 0 0-.889.889V19.61a.89.89 0 0 0 .89.889h18.221a.889.889 0 0 0 .89-.889V1.39a.889.889 0 0 0-.89-.889Z"/><path fill="#fff" d="M4.5 18.278h12.889a.89.89 0 0 0 .889-.89V4.057a.889.889 0 0 0-.89-.89H4.5a.889.889 0 0 0-.889.89V17.39c0 .49.398.889.889.889Z"/><path stroke="#743CCD" stroke-width=".667" d="M17.389 17.944H4.499a.556.556 0 0 1-.555-.555V4.056c0-.307.249-.556.556-.556h12.889c.307 0 .555.249.555.556v13.333a.555.555 0 0 1-.555.555Z"/><path fill="#E8DFF7" d="M8.944 4.056H8.5v13.333h.444V4.056Z"/><path fill="#E8DFF7" d="M17.389 9.389v-.445H4.499v.445h12.89Zm0 2.667v-.445H4.499v.445h12.89Zm0 2.666v-.444H4.499v.444h12.89Z"/><path fill="#E8DFF7" d="M13.389 4.056h-.445v13.333h.445V4.056Z"/><path fill="#E8DFF7" d="M17.389 6.722v-.444H4.499v.444h12.89Z"/><path fill="#743CCD" d="M8.5 4.056h-4v2.222h4V4.056Z"/><path fill="#743CCD" d="M8.5 4.056h-4v2.222h4V4.056Z"/><path fill="#DFFE8F" d="M12.944 4.056h-4v2.222h4V4.056Z"/><path fill="#E8DFF7" d="M17.389 4.056h-4v2.222h4V4.056Z"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z" transform="translate(.944 .5)"/></clipPath></defs></svg>`,
		description: 'Simple balance sheet table',
	},
	{
		title: 'Company Letterhead',
		icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 21 21"><g clip-path="url(#a)"><path fill="#E8DFF7" d="M19.611.5H1.39a.889.889 0 0 0-.889.889V19.61c0 .491.398.889.889.889h18.22a.889.889 0 0 0 .889-.889V1.39a.889.889 0 0 0-.888-.89Z"/><path fill="#fff" d="M4.5 17.167c0 .859.696 1.555 1.556 1.555h8.888c.86 0 1.556-.696 1.556-1.555V6.539c0-.448-.194-.875-.531-1.17l-2.585-2.262a1.555 1.555 0 0 0-1.024-.385H6.056c-.86 0-1.556.697-1.556 1.556v12.889Z"/><path stroke="#743CCD" stroke-width=".667" d="M15.939 5.785c.145.127.228.31.228.502v11.435a.667.667 0 0 1-.667.667h-10a.667.667 0 0 1-.667-.667v-14c0-.368.299-.666.667-.666h7.069c.161 0 .317.058.439.165l2.93 2.564Z"/><rect width="4.889" height=".667" x="6.278" y="8.944" fill="#743CCD" rx=".333"/><rect width="6.667" height=".667" x="6.278" y="10.722" fill="#743CCD" rx=".333"/><rect width="4.889" height=".667" x="6.278" y="12.5" fill="#743CCD" rx=".333"/><rect width="4.889" height=".667" x="6.278" y="14.278" fill="#743CCD" rx=".333"/><rect width="7.111" height=".667" x="6.278" y="16.055" fill="#743CCD" rx=".333"/><circle cx="7.611" cy="6.278" r="1.333" fill="#C9FE43"/><rect width="4" height=".667" x="9.833" y="6.278" fill="#743CCD" rx=".333"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z" transform="translate(.5 .5)"/></clipPath></defs></svg>`,
		data: `<table style="border-width:0">
							<colgroup>
								<col style="width:30%;">
								<col style="width:70%;">
							</colgroup>
							<tbody>
								<tr>
									<td style="width:30%;">
										<figure class="image">
											<picture>
												<img src="/assets/images/ckdemo/productivity-pack/matata-logo.png">
											</picture>
										</figure>
									</td>
									<td>
										<span><a href="mailto:info@matataventures.co"><span style="background-color:transparent;color:#1155cc;"><u>info@matataventures.co</u></span></a><br>
										<span>1 Bonnyville Dr. Spryfield B3P 1H8</span><br>
										<span>+1-613-555-0133</span></span>
										<div></div>
									</td>
								</tr>
							</tbody>
						</table>`,
		description: 'Document letterhead with logo',
	},
];

export const IMPORT_CONFIG = {
	converterUrl: 'https://docx-converter.cke-cs.com/v2/convert/docx-html',
};

export const PARAGRAPH_STYLES = [
	'background-color',
	'line-height',
	'border-left',
	'border-right',
	'border-top',
	'border-bottom',
	'text-indent',
	'margin-top',
	'margin-bottom',
	'margin-left',
	'margin-right',
	'padding-top',
	'padding-bottom',
	'padding-left',
	'padding-right',
];

export const HTML_SUPPORT_CONFIG = {
	allow: [
		{
			name: 'p',
			styles: PARAGRAPH_STYLES,
		},
		{
			name: /^h[1-6]$/u,
			styles: PARAGRAPH_STYLES,
		},
		{
			name: 'span',
			styles: ['letter-spacing', 'font-variant-caps', 'font-stretch'],
		},
		{
			name: 'figure',
			classes: [
				'table',
				'table-style-align-left',
				'table-style-align-right',
				'table-style-align-center',
				'table-style-align-block-left',
				'table-style-align-block-right',
			],
			styles: ['margin-left', 'margin-right'],
		},
		{
			name: 'table',
			styles: ['border-collapse', 'border-spacing'],
		},
		{
			name: /^td|th$/u,
			styles: ['vertical-align'],
		},
		{
			name: /^ul|ol|li$/u,
			styles: ['list-style-type'],
		},
	],
};
